import { computed, ref } from 'vue'

export function useStoryFilmPlayer(execution, selectedShot) {
  const executionVideo = ref(null)
  const executionVideoUrl = ref(null)
  const currentVideoTime = ref(0)
  const mediaState = ref('not-recorded') // 'loading' | 'ready' | 'not-recorded' | 'error'
  const mediaError = ref('')

  const totalShotsDurationMs = computed(() => {
    const shots = execution.value?.shots ?? []
    if (!shots.length) return 0
    const last = shots[shots.length - 1]
    return Number.isFinite(last?.end_ms) ? last.end_ms : (execution.value?.media?.duration_ms ?? 0)
  })

  const playheadPercent = computed(() => {
    const total = totalShotsDurationMs.value
    if (!total || total <= 0) return 0
    const currentMs = currentVideoTime.value * 1000
    return Math.min(100, Math.max(0, (currentMs / total) * 100))
  })

  function onTimeUpdate(event) {
    currentVideoTime.value = event.target.currentTime
  }

  function onVideoMetadata() {
    mediaState.value = 'ready'
  }

  function onVideoReady() {
    mediaState.value = 'ready'
  }

  function onVideoError() {
    mediaState.value = 'error'
    mediaError.value = '视频资源加载失败'
  }

  function togglePlay() {
    if (!executionVideo.value) return
    if (executionVideo.value.paused) {
      void executionVideo.value.play()
    } else {
      executionVideo.value.pause()
    }
  }

  function seekPlannedShot() {
    if (!executionVideo.value || !selectedShot.value || !Number.isFinite(selectedShot.value.start_ms)) return
    executionVideo.value.currentTime = selectedShot.value.start_ms / 1000
    void executionVideo.value.play()
  }

  function formatSeconds(ms) {
    if (!Number.isFinite(ms)) return '0:00.00'
    const totalSec = ms / 1000
    const mins = Math.floor(totalSec / 60)
    const secs = (totalSec % 60).toFixed(2).padStart(5, '0')
    return `${mins}:${secs}`
  }

  function getShotDuration(shot) {
    if (shot && Number.isFinite(shot.start_ms) && Number.isFinite(shot.end_ms) && shot.end_ms >= shot.start_ms) {
      return ((shot.end_ms - shot.start_ms) / 1000).toFixed(2) + 's'
    }
    return ''
  }

  function getShotFlex(shot) {
    if (shot && Number.isFinite(shot.start_ms) && Number.isFinite(shot.end_ms) && shot.end_ms > shot.start_ms) {
      return Math.max(1000, Math.round(shot.end_ms - shot.start_ms))
    }
    return 4000
  }

  function clearVideo() {
    if (executionVideoUrl.value) {
      URL.revokeObjectURL(executionVideoUrl.value)
      executionVideoUrl.value = null
    }
    currentVideoTime.value = 0
    mediaState.value = 'not-recorded'
    mediaError.value = ''
  }

  return {
    executionVideo,
    executionVideoUrl,
    currentVideoTime,
    mediaState,
    mediaError,
    totalShotsDurationMs,
    playheadPercent,
    onTimeUpdate,
    onVideoMetadata,
    onVideoReady,
    onVideoError,
    togglePlay,
    seekPlannedShot,
    formatSeconds,
    getShotDuration,
    getShotFlex,
    clearVideo,
  }
}

